import { ProductPageLayout } from '../components/ProductPageLayout';

export function FotoProductWorkflowPage() {
    return <ProductPageLayout productId="foto-product-workflow" />;
}
